module.exports = __webpack_public_path__ + "img/floor.f5be37b1.svg";